export default __webpack_public_path__ + "static/media/ic-clock.abffd7d1.svg";